import { n as cx } from "./primitives-DLlUP8hy.js";
import { H as XMarkIcon } from "./icons-JHd5kZB_.js";
import { t as Button$1 } from "./button-Cl4XuJpV.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { twMerge } from "tailwind-merge";
import { Button, Dialog, Heading } from "react-aria-components";
var Dialog$1 = ({ role: e = "dialog", className: h,...g }) => /* @__PURE__ */ jsx(Dialog, {
	"data-slot": "dialog",
	role: e,
	className: twMerge("peer/dialog group/dialog relative flex max-h-[calc(var(--visual-viewport-height)-var(--visual-viewport-vertical-padding))] flex-col overflow-hidden outline-hidden [--gutter:--spacing(6)] sm:[--gutter:--spacing(8)]", h),
	...g
}), DialogTrigger$1 = ({ className: h,...g }) => /* @__PURE__ */ jsx(Button, {
	className: cx("cursor-pointer", h),
	...g
}), DialogHeader = ({ className: e,...h }) => /* @__PURE__ */ jsxs("div", {
	"data-slot": "dialog-header",
	className: twMerge("relative space-y-1 p-(--gutter) pb-[calc(var(--gutter)---spacing(3))]", e),
	children: [
		h.title && /* @__PURE__ */ jsx(DialogTitle, { children: h.title }),
		h.description && /* @__PURE__ */ jsx(DialogDescription, { children: h.description }),
		!h.title && typeof h.children == "string" ? /* @__PURE__ */ jsx(DialogTitle, { children: h.children }) : h.children
	]
}), DialogTitle = ({ className: e, ref: h,...g }) => /* @__PURE__ */ jsx(Heading, {
	slot: "title",
	ref: h,
	className: twMerge("text-balance font-semibold text-fg text-lg/6 sm:text-base/6", e),
	...g
}), DialogDescription = ({ className: e, ref: h,...g }) => /* @__PURE__ */ jsx("p", {
	"data-slot": "description",
	className: twMerge("text-pretty text-base/6 text-muted-fg group-disabled:opacity-50 sm:text-sm/6", e),
	ref: h,
	...g
}), DialogBody = ({ className: e,...h }) => /* @__PURE__ */ jsx("div", {
	"data-slot": "dialog-body",
	className: twMerge("isolate flex min-h-0 flex-1 flex-col overflow-auto px-(--gutter) py-1", "**:data-[slot=dialog-footer]:px-0 **:data-[slot=dialog-footer]:pt-0", e),
	...h
}), DialogFooter = ({ className: e,...h }) => /* @__PURE__ */ jsx("div", {
	"data-slot": "dialog-footer",
	className: twMerge("isolate mt-auto flex flex-col-reverse justify-end gap-3 p-(--gutter) pt-[calc(var(--gutter)---spacing(2))] group-not-has-data-[slot=dialog-body]/dialog:pt-0 group-not-has-data-[slot=dialog-body]/popover:pt-0 sm:flex-row", e),
	...h
}), DialogClose = ({ intent: e = "plain", ref: h,..._ }) => /* @__PURE__ */ jsx(Button$1, {
	slot: "close",
	ref: h,
	intent: e,
	..._
}), DialogCloseIcon = ({ className: g,..._ }) => _.isDismissable ? /* @__PURE__ */ jsx(Button, {
	"aria-label": "Close",
	slot: "close",
	className: cx("close absolute top-1 right-1 z-50 grid size-8 place-content-center rounded-xl hover:bg-secondary focus:bg-secondary focus:outline-hidden focus-visible:ring-1 focus-visible:ring-primary sm:top-2 sm:right-2 sm:size-7 sm:rounded-md", g),
	children: /* @__PURE__ */ jsx(XMarkIcon, { className: "size-4" })
}) : null;
export { DialogDescription as a, DialogTitle as c, DialogCloseIcon as i, DialogTrigger$1 as l, DialogBody as n, DialogFooter as o, DialogClose as r, DialogHeader as s, Dialog$1 as t };
